/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Lot_CodeInputs */

const vi_tea_lot_code = /** @type {(inputs: Tea_Lot_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lô`)
};

/**

* @param {Tea_Lot_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_lot_code = /** @type {((inputs?: Tea_Lot_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Lot_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_lot_code(inputs)
});